<template>
  <div class="project" v-drag> 
    <div  role="document">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-title">-- {{data_title}} --</span>
          <span aria-hidden="true" class="modal-span" @click="close">&times;</span>
        </div>
        <div class="modal-body">

          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <template v-for="(item,index) in head_data">
                <th :key="index" v-if="item.Name=='fld_name'">{{item.Comment}}</th>
                </template>
                <th><input type="checkbox" v-model="btn_check" @change="btn_sel"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list,index) in list_data" :key="index" @click="col_check(list.fld_name)">
                <template v-for="(child_list,index) in head_data"> 
                <td :key="index" v-if="child_list.Name=='fld_name'">{{list[child_list.Name]}}</td>
                </template>
                <td ><input type="checkbox" v-model="check_data" :value="list.fld_name"></td> 
              </tr>                   
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default btn-default-close" data-dismiss="modal" @click="cancel_selection">{{cancel}}</button>
          <button type="button" class="btn btn-default-determine" @click="determine(key_s.Name)">{{confirm}}</button>
        </div>
        <div class="loading" v-if="anate"><i class="fa fa-spin fa-spinner"></i></div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import api from "../api/index.js"
  export default {
    name: 'Project',
    components: {
    },
    computed:{
      confirm(){
        return this.$attrs.language_pack[this.sel_language].confirm
      },
      cancel(){
        return this.$attrs.language_pack[this.sel_language].cancel
      },
      ...mapState({
        sel_language:'sel_language'
      })
    },
    data(){
      return {
       //加载状态
      anate:true,
      head_data:null,
      btn_check:'',
      check_data:[],
      //数据列表
      list_data:[],
    //   show_data:[],
      btn_data:this.rule_data,
      data_title:'',
      tb_key:'',
      }
    },
    mounted(){
        this.is_checked(this.btn_data);
        this.load_data(this.key_s.Name)
       
    },
    props:{
      ppr_action:String,
      ppr_action_param:String,
      rule_data:String,
      key_s:Object
    },
    watch: {
        list_data(){
            if(!this.btn_data){
                if(this.tb_key=='fld_country'){
                  this.list_data.forEach((item,index)=>{
                    this.check_data.push(item.fld_name)
                  })
                }
            }
            this.btn_check=true
        }
    },
    methods:{
        //请求接口数据
        async load_data(key){
            if(key=='fld_country'){              
              this.tb_key='fld_country';
                let res= await this.async_error(api.getTableHead('/Sandbox/Launcher/tbl_country',window.sessionStorage.getItem('userInfo')))
                this.head_data=res.data.FIELDS;
                let para={};
                para.userInfo=window.sessionStorage.getItem('userInfo');
                let res1= await this.async_error(api.getBoxData(res.data,para))
                this.list_data=res1.data;
                this.data_title='tbl-country';
                this.anate=false;
            }
        },
        //捕获异步错误
		async_error(promise){
			return promise.then(res => res).catch(error => this.error_message(error));
		},
        //读取输入框中的值如果有值就选中对应的复选框
        is_checked(btn_data){
            if(btn_data){
                var data=null;
                data=btn_data.split(';')
                if(this.key_s=='fld_country'){
                  data.forEach((item,index)=>{
                  this.check_data.push(item)
                  })
                }
                this.btn_check=true;
            }
        },
        //点击tr元素选中checkbox标签
       col_check(i){
         
        //当复选框绑定的数组长度为0时把value值push进数组
        if(this.check_data.length==0){
          this.check_data.push(i);
        }else if(this.check_data.every((item,index)=>{return item!=i})){//当数组中的每一项都不等于当前的value值时把值push进去
          this.check_data.push(i);
        }else{
          this.check_data=this.check_data.filter((item,index)=>{//当数组中的某一项和当前点击的value项有相同的就移除出去
            return i!=item
          });
        }
        //当数组长度大于0时总按钮选中
        if(this.check_data.length>0){
          this.btn_check=true;
        };
        //当数组长度等于0时总按钮取消选中
        if(this.check_data.length==0){
          this.btn_check=false;
        };
      },
      //点击关闭图标
      close(){
        this.$emit('close_project')
      },
      //点击取消
      cancel_selection(){
        this.check_data=[];
        this.btn_check='';
      },
      //点击确定
      determine(key){
        var data=[];
        if(key=='fld_country'){
          this.check_data.forEach((item,index)=>{
            data.push(item)
          }) ;
        }
        data=data.length?data:undefined
        if(data){
          data=data.join(',').replace(/\,/g,';');
        }
        
        // data=JSON.stringify(data)
        this.$emit('input_data',data) 
      },
      //头部复选框
      btn_sel(){



        if(this.btn_check==true){
          this.list_data.forEach((item,i)=>{
            if(this.tb_key=='fld_country'){
              if(this.check_data.length==0){
              this.check_data.push(item.fld_name);
              }else if(this.check_data.every((item,index)=>{return item!=item.fld_name})){//当数组中的每一项都不等于当前的value值时把值push进去
                this.check_data.push(item.fld_name);
              }
            }
          })
        }else{
          this.list_data.forEach((ite,i)=>{
            if(this.tb_key=='fld_country'){
              this.check_data=this.check_data.filter((item,index)=>{//当数组中的某一项和当前点击的value项有相同的就移除出去
              return ite.fld_name!=item
            });
            }
          })
        }
      },
    },
    directives: {
      drag: {
        inserted(el) {
          let drag_Box = el; //获取当前元素
          let dragBox = document.getElementsByClassName('modal-header')[0];
          dragBox.onmousedown = e => {
            //算出鼠标相对元素的位置
            let disX = e.clientX - drag_Box.offsetLeft;
            let disY = e.clientY - drag_Box.offsetTop;
            document.onmousemove = e => {
              //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
              let left = e.clientX - disX;
              let top = e.clientY - disY;
              //移动当前元素
              drag_Box.style.left = left + "px";
              drag_Box.style.top = top + "px";
            };
            document.onmouseup = e => {
              //鼠标弹起来的时候不再移动
              document.onmousemove = null;
              //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）  
              document.onmouseup = null;
            };
          };
        }
      }
    }
  }
</script>
<style scoped>
  .modal-content{
	min-width: 500px;
}
  .modal-header{
    cursor: move;
  }
  .modal-body{
    max-height: 500px;
    overflow: auto;
  }
  .table>tbody>tr>td {
     text-align: center;
  } 
  .table>thead>tr>th {
      text-align: center;
 }
  	.loading{
		z-index: 1000;
		font-size: 50px;
		position: absolute;
		color: rgb(138, 132, 132);
		top: 50%;
		left: 50%;
		/* transform: translate(-50%, -50%); */
    overflow: visible;
	  bottom: inherit;
	  right: inherit;
	  transform: translate(calc(-50% + 0.5px), calc(-50% + 0.5px));
		text-align: center;
	}
	.project{
    position: fixed;
    top: 50%;
    left: 50%;
    z-index:999;
    /* transform: translate(-50%, -50%); */
    overflow: visible;
	  bottom: inherit;
	  right: inherit;
	  transform: translate(calc(-50% + 0.5px), calc(-50% + 0.5px));
  }
 .modal-header{
		background:#ebecf0;
		height:40px
	}
 .modal-span{
		font-size:20px;
		margin-top:-14px;
		cursor:pointer
	}
	.modal-title{
		line-height:1px
	}
  .btn-default-close{
    color:#007bff;
		font-size:12px;
		border:1px solid #808080;
		padding:4px;
		/* margin-right: 393px; */
  }
  .modal-footer{
    justify-content: space-between;
    /* width: 500px; */
  }
  .btn-default-determine{
    color:#007bff;
		font-size:12px;
		border: 1px solid rgb(128, 128, 128);
		padding: 4px;
  }
  td{
    font-size: 12px;
  }
  </style>